module.exports = __webpack_public_path__ + "img/t6-teal.498717b1.png";